var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessCheckRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#B7E6CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 18.6205L11.8325 16.4531C11.6094 16.23 11.2476 16.23 11.0244 16.4531C10.8013 16.6763 10.8013 17.0381 11.0244 17.2612L13.5959 19.8327C13.819 20.0558 14.1808 20.0558 14.404 19.8327L20.6897 13.547C20.9128 13.3238 20.9128 12.962 20.6897 12.7388C20.4665 12.5157 20.1047 12.5157 19.8816 12.7388L13.9999 18.6205Z",
    fill: "#32B76C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckRounded);
export default __webpack_public_path__ + "static/media/success-check-rounded.d36cce5d4f2638e2902d33b16c0321af.svg";
export { ForwardRef as ReactComponent };